// src/icons/svgs/eye-dropper.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var SvgEyeDropper = (props, ref) => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ref, ...props, children: [
  /* @__PURE__ */ jsx("g", { clipPath: "url(#69eda)", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 0 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708zM2 12.707l7-7L10.293 7l-7 7H2z" }) }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "69eda", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 0h16v16H0z" }) }) })
] });
var ForwardRef = forwardRef(SvgEyeDropper);
var eye_dropper_default = ForwardRef;
export {
  eye_dropper_default as EyeDropper
};
